<template>
  <section
    class="bg-[url('/assets/img/caring.png')] bg-cover bg-no-repeat bg-[#010104] md:rounded-xl py-8 md:py-15 md:container md:w-[92%] md:mx-auto"
  >
    <div
      class="flex !w-[92%] md:!w-full max-md:container mx-auto relative my-auto md:px-12 pb-12"
    >
      <div class="banner-text w-full lg:w-2/3 xl:w-[45%] pt-14 z-[1]">
        <h2 class="section-heading-white mb-8">
          Sharing is Caring, That's What We are Living
        </h2>
        <p
          class="text-white text-sm sm:text-base w-full md:w-[95%] font-normal mb-8"
        >
          We believe that you have the power to create lasting change in the
          lives of those in need. By getting involved in our social programs
          through donations, no matter how big or small, you help us to create a
          brighter future for others. Together, let's take action to make a
          significant impact!
        </p>
        <NuxtLink
          to="/sustainability"
          title="Sustainability"
          class="px-3 py-[10px] sm:py-3 sm:px-4 text-white border border-white rounded-md block w-max text-sm sm:text-base font-medium hover:bg-white hover:text-black-900"
          >View Sustainability</NuxtLink
        >
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style lang="scss" scoped></style>
